export default {
  wechatinfo: '/v3/recruit/wechatinfo'
}
